import { MemberCardIcon } from "@/components/MemberCardIcon";
import { useMembership } from "@/lib/membership";

/** Shop notice for System Members; nothing for everyone else. */
export function MemberPricingBanner() {
  const { percent } = useMembership();
  if (!percent) return null;
  return (
    <div className="mx-15 mt-13 flex items-center gap-10 border border-success bg-success-wash px-12 py-12">
      <MemberCardIcon />
      <p className="font-body text-14 leading-135 text-ink">
        <strong>Member pricing on.</strong> {percent}% off every treatment,
        applied automatically at checkout.
      </p>
    </div>
  );
}
